import './App.css';
import React, { Component } from 'react';
import * as HomeComponent from './Home';
import { Navbar } from './Home/Navbar';

import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import KeepKitCU from './Pages/Projects/KeepKitCU';
import WriteyKidsCU from './Pages/Projects/WriteyKidsCU';

class App extends Component {
  render() {
    return (
      <Routes>

        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/projects/KeepKitCU"
          element={<KeepKitCU />}
        />

        <Route
          path="/projects/WriteyKidsCU"
          element={<WriteyKidsCU />}
        />

      </Routes>
    );
  }
}

export default App;
